export default __webpack_public_path__ + "static/media/bucket.c3cee919.ogg";